import React from 'react';
import ShopToClubHeaderWrapper from 'Components/SignupOverlay/ShopToClubHeaderWrapper';
import { Title } from 'SharedComponents/styled/overlay/Title';
import useTranslate from 'Hooks/useTranslate';

interface OverlayContentHeaderProps {
    isLogin: boolean;
}

const OverlayContentHeader: React.FunctionComponent<OverlayContentHeaderProps> = ({ isLogin }) => {
    const { t } = useTranslate();
    const loginView = <Title>{t('signupOverlay_Login title')}</Title>;
    const registerView = <ShopToClubHeaderWrapper />;

    return <>{isLogin ? loginView : registerView}</>;
};

export default OverlayContentHeader;
